import styled from 'styled-components';
import colors from 'styles/colors';
import { LoadingSpinMixin } from 'styles/animation';

export const Container = styled.div`
  position: absolute;
`;

export const Content = styled.div`
  position: relative;
`;

export const LoadingBox = styled.div<{ color?: string }>`
  width: 1.3em;
  height: 1.3em;
  margin: 0 auto;
  border: 0.19em solid ${(props) => (props.color ? props.color : colors.white)};
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;

  ${LoadingSpinMixin};
`;

export const SpinnerWrapper = styled.div<{ backgroundColor?: string; color?: string }>`
  align-items: center;
  background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : colors.white)};
  flex: 1 0 auto;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;

  ${LoadingBox} {
    height: 10em;
    width: 10em;
    border-color: ${(props) => (props.color ? props.color : colors.highlight)};
    border-left-color: transparent;
    border-right-color: transparent;
  }
`;

export const LoadingImg = styled.div`
  width: 1.3em;
  height: 1.3em;
  margin: 0 auto;
  border: 0.19em solid ${colors.white};
  border-radius: 50%;
  border-left-color: transparent;
  border-right-color: transparent;

  ${LoadingSpinMixin};
`;
